module.exports = __webpack_public_path__ + "img/advertisement-puppy-pack.e750add3.jpg";